// extracted by mini-css-extract-plugin
export default {"dropdownHeading":"AccountDropdown_dropdownHeading__4aLI5"};